import React, { FunctionComponent, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './heading.module.scss';

export type HeadingProps = {
  children: ReactNode;
  level?: number;
  scale?: number;
  className?: string;
  breakPoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | null;
  margin?: 'none' | 'bottom' | 'both' | 'top';
};

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'strong';

const Heading: FunctionComponent<React.PropsWithChildren<HeadingProps>> = ({
  children,
  level = 2,
  scale = 2,
  className = '',
  breakPoint = null,
  margin = 'both',
}) => {
  const Tag = ((level <= 6 && `h${level}`) || `strong`) as HeadingTag;
  const tagClassName = classNames(
    styles.h,
    {
      [styles[`scale-${scale}`]]: scale,
      [styles.hBlock]: level === 7,
      [styles[`margin-${margin}`]]: margin !== 'none',
      [styles[`breakpoint-${breakPoint}`]]: breakPoint,
    },
    className,
  );

  const tagProps = {
    className: tagClassName,
    ...(Tag === 'strong' ? { role: 'heading' } : {}),
  };

  return <Tag {...tagProps}>{children}</Tag>;
};

export default Heading;
